import { t } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import { Chip } from '@pocketlaw/tetris';
const DATE_FORMAT = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};
export function Date(props) {
    const { createdAt } = props;
    const { i18n } = useLingui();
    if (!createdAt) {
        return null;
    }
    return (<Chip appearance="secondary" variant="outline" size="small" label={t({
            comment: 'Universal search - Added label for date field',
            message: 'Added',
        })} secondary={i18n.date(createdAt, DATE_FORMAT)}/>);
}
